export const search_options = [
  { id: 1, label: 'CPF', value: 'cpf' },
  { id: 2, label: 'ID', value: 'CreditRequestId' },
  { id: 3, label: 'EMAIL', value: 'email' },
  { id: 4, label: 'NOME', value: 'name' },
]
